<h1 mat-dialog-title >Búsqueda Múltiple</h1>
<div mat-dialog-content>
  <div class="row">
    <div class=" col-6 ">
      <form>
        <label class="form-label">Nº Expediente</label>
        <div class="input-group">
          <input type="text"  class="form-control" matTooltip="Comience a escribir un número de expediente para filtrar." [(ngModel)]="numPedido" [ngModelOptions]="{standalone: true}">
          <div class="input-group-append">
            <span class="input-group-text"><mat-icon matTooltip="Búsqueda múltiple" (click)="addToPedidosList()">add</mat-icon></span>

          </div>
        </div>
      </form>


    </div>
    <div class="col-6">
      <div class="row" *ngFor="let p of pedidos; let i = index">
        <div class="col-10">
          <label>{{p}}</label>
        </div>
        <div class="col-1"><mat-icon (click)="removeFromList(i)">delete_forever</mat-icon></div>
      </div>


    </div>
  </div>




</div>
<mat-dialog-actions align="end">
  <button mat-button  mat-dialog-close>Cancelar</button>
  <button mat-button [disabled]="pedidos.length === 0"  [mat-dialog-close]="pedidos">Aceptar</button>
</mat-dialog-actions>
